import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo.png'
import _imports_1 from '../../assets/img/logo-white.png'
import _imports_2 from '../../assets/img/icons/sidebar-menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-01c0d505"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar navbar-expand-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand d-lg-none" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-light",
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-dark",
    src: _imports_1,
    alt: "logo"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-option d-lg-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "option-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "search-btn",
      "data-bs-toggle": "modal",
      "data-bs-target": "#searchModal"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "ri-search-line" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-toggler",
    "data-bs-toggle": "offcanvas",
    href: "#navbarOffcanvas",
    role: "button",
    "aria-controls": "navbarOffcanvas"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "burger-menu" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "top-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "middle-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "bottom-bar" })
    ])
  ])
], -1))
const _hoisted_5 = { class: "collapse navbar-collapse" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "sidebar-toggler",
  "data-bs-toggle": "offcanvas",
  href: "#navbarOffcanvas",
  role: "button",
  "aria-controls": "navbarOffcanvas"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Image"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<ul class=\"navbar-nav\" data-v-01c0d505><li class=\"nav-item\" data-v-01c0d505><span class=\"nav-link\" data-v-01c0d505>Home</span></li></ul><div class=\"navbar-brand mx-auto\" data-v-01c0d505><img class=\"logo-light\" src=\"" + _imports_0 + "\" alt=\"logo\" data-v-01c0d505><img class=\"logo-dark\" src=\"" + _imports_1 + "\" alt=\"logo\" data-v-01c0d505></div>", 2)
const _hoisted_9 = { class: "others-option d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"option-item\" data-v-01c0d505><form action=\"#\" class=\"search-form\" data-v-01c0d505><input type=\"text\" placeholder=\"Search\" data-v-01c0d505><button type=\"submit\" data-v-01c0d505><i class=\"ri-search-line\" data-v-01c0d505></i></button></form></div>", 1)
const _hoisted_11 = { class: "option-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['navbar-area', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-franchise",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToFranchiseForm && _ctx.scrollToFranchiseForm(...args)))
              }, " Apply Franchise ")
            ])
          ])
        ])
      ])
    ])
  ], 2))
}